const doc = [({"da":({"js":({"admin":({"highscore_generations":({"nav":({"overall_highscore":"Samlet highscore", "participants":"Deltagere"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;